// import img1 from '/public/images/hotel1.jpeg';
import img1 from "../../../assets/images/hotel1.jpeg";
import img22 from "../../../assets/images/hotel9.jpg";
import img23 from "../../../assets/images/hotel10.jpg";
import img24 from "../../../assets/images/hotel11.jpg";
import img2 from "../../../assets/images/hotel5.jpeg";
import img3 from "../../../assets/images/hotel2.jpeg";
import img4 from "../../../assets/images/hotel3.jpeg";
import img5 from "../../../assets/images/hotel4.jpeg";
import img6 from "../../../assets/images/hotel6.jpeg";
import img7 from "../../../assets/images/hotel7.jpeg";
import img8 from "../../../assets/images/hotel8.jpeg";
import img9 from "../../../assets/images/hotel8.jpg";
import img10 from "../../../assets/images/2026_hm/1000640629.jpg";
import img11 from "../../../assets/images/2026_hm/1000640630.jpg";
import img12 from "../../../assets/images/2026_hm/1000640631.jpg";
import img13 from "../../../assets/images/2026_hm/1000640632.jpg";
import img14 from "../../../assets/images/2026_hm/1000640633.jpg";
import img15 from "../../../assets/images/2026_hm/1000640634.jpg";
import img16 from "../../../assets/images/2026_hm/1000640635.jpg";
import img17 from "../../../assets/images/2026_hm/1000640636.jpg";
import img18 from "../../../assets/images/2026_hm/1000640637.jpg";
import img19 from "../../../assets/images/2026_hm/1000640638.jpg";
import img20 from "../../../assets/images/2026_hm/1000640639.jpg";
import img21 from "../../../assets/images/2026_hm/1000640640.jpg";
import img25 from "../../../assets/images/2026_hm/1000640641.jpg";
import img26 from "../../../assets/images/2026_hm/1000640642.jpg";
import img27 from "../../../assets/images/2026_hm/1000640643.jpg";
import img28 from "../../../assets/images/2026_hm/1000640644.jpg";
import img29 from "../../../assets/images/2026_hm/1000640645.jpg";
import img30 from "../../../assets/images/2026_hm/1000640646.jpg";
import img31 from "../../../assets/images/2026_hm/1000640647.jpg";
import img32 from "../../../assets/images/2026_hm/1000640648.jpg";
import img33 from "../../../assets/images/2026_hm/1000640649.jpg";
import img34 from "../../../assets/images/2026_hm/1000640650.jpg";
import img35 from "../../../assets/images/2026_hm/1000640651.jpg";
import img36 from "../../../assets/images/2026_hm/1000640652.jpg";
import img37 from "../../../assets/images/2026_hm/1000640653.jpg";
import img38 from "../../../assets/images/2026_hm/1000640654.jpg";
import img39 from "../../../assets/images/2026_hm/1000640655.jpg";
import img40 from "../../../assets/images/2026_hm/1000640656.jpg";
import img41 from "../../../assets/images/2026_hm/1000640657.jpg";
import img42 from "../../../assets/images/2026_hm/1000640658.jpg";
import img43 from "../../../assets/images/2026_hm/1000640659.jpg";
import img44 from "../../../assets/images/2026_hm/1000640660.jpg";
import img45 from "../../../assets/images/2026_hm/1000640661.jpg";
import img46 from "../../../assets/images/2026_hm/1000640662.jpg";
import img47 from "../../../assets/images/2026_hm/1000640663.jpg";
import img48 from "../../../assets/images/2026_hm/1000640664.jpg";
import img49 from "../../../assets/images/2026_hm/1000640665.jpg";
import img50 from "../../../assets/images/2026_hm/1000640666.jpg";
import img51 from "../../../assets/images/2026_hm/1000640667.jpg";
import img52 from "../../../assets/images/2026_hm/1000640668.jpg";
import img53 from "../../../assets/images/2026_hm/1000640669.jpg";
import img54 from "../../../assets/images/2026_hm/1000640670.jpg";
import img55 from "../../../assets/images/2026_hm/1000640671.jpg";
import img56 from "../../../assets/images/2026_hm/1000640672.jpg";
import img57 from "../../../assets/images/2026_hm/1000640673.jpg";
import img58 from "../../../assets/images/2026_hm/1000640674.jpg";
import img59 from "../../../assets/images/2026_hm/1000640675.jpg";
import img60 from "../../../assets/images/2026_hm/1000640676.jpg";
import img61 from "../../../assets/images/2026_hm/1000640677.jpg";

export const Activities = [
  { id: 1, Avatar: img1 },
  { id: 2, Avatar: img2 },
  { id: 3, Avatar: img3 },
  { id: 4, Avatar: img4 },
  { id: 5, Avatar: img5 },
  { id: 6, Avatar: img6 },
  { id: 7, Avatar: img7 },
  { id: 8, Avatar: img8 },
  { id: 9, Avatar: img9 },
  { id: 10, Avatar: img10 },
  { id: 11, Avatar: img11 },
  { id: 12, Avatar: img12 },
  { id: 10, Avatar: img10 },
  { id: 11, Avatar: img11 },
  { id: 12, Avatar: img12 },
  { id: 13, Avatar: img13 },
  { id: 14, Avatar: img14 },
  { id: 15, Avatar: img15 },
  { id: 16, Avatar: img16 },
  { id: 17, Avatar: img17 },
  { id: 18, Avatar: img18 },
  { id: 19, Avatar: img19 },
  { id: 20, Avatar: img20 },
  { id: 21, Avatar: img21 },
  { id: 22, Avatar: img22 },
  { id: 23, Avatar: img23 },
  { id: 24, Avatar: img24 },
  { id: 25, Avatar: img25 },
  { id: 26, Avatar: img26 },
  { id: 27, Avatar: img27 },
  { id: 28, Avatar: img28 },
  { id: 29, Avatar: img29 },
  { id: 30, Avatar: img30 },
  { id: 31, Avatar: img31 },
  { id: 32, Avatar: img32 },
  { id: 33, Avatar: img33 },
  { id: 34, Avatar: img34 },
  { id: 35, Avatar: img35 },
  { id: 36, Avatar: img36 },
  { id: 37, Avatar: img37 },
  { id: 38, Avatar: img38 },
  { id: 39, Avatar: img39 },
  { id: 40, Avatar: img40 },
  { id: 41, Avatar: img41 },
  { id: 42, Avatar: img42 },
  { id: 43, Avatar: img43 },
  { id: 44, Avatar: img44 },
  { id: 45, Avatar: img45 },
  { id: 46, Avatar: img46 },
  { id: 47, Avatar: img47 },
  { id: 48, Avatar: img48 },
  { id: 49, Avatar: img49 },
  { id: 50, Avatar: img50 },
  { id: 51, Avatar: img51 },
  { id: 52, Avatar: img52 },
  { id: 53, Avatar: img53 },
  { id: 54, Avatar: img54 },
  { id: 55, Avatar: img55 },
  { id: 56, Avatar: img56 },
  { id: 57, Avatar: img57 },
  { id: 58, Avatar: img58 },
  { id: 59, Avatar: img59 },
  { id: 60, Avatar: img60 },
  { id: 61, Avatar: img61 },
];
